const data = document.currentScript.dataset;

const sentryconfig = generateSentryConfig(data);
document.body.appendChild(sentryconfig);

function generateSentryConfig(data) {
  const sentryconfig = document.createElement('sentry-config');
  sentryconfig.setAttribute('project-name', data.projectName);
  sentryconfig.setAttribute('project-dsn', data.projectDsn);
  sentryconfig.setAttribute('project-id', data.projectId);
  sentryconfig.setAttribute('project-files', data.projectFiles);
  sentryconfig.setAttribute('release-version', data.releaseVersion);
  return sentryconfig;
}